import { InvoiceSendOptions } from "../../../domain/invoicing/invoicingApi"
import { SendStatementRequest } from "../../../domain/invoicing/statementsApi"
import { StatementSummary } from "../../../domain/invoicing/statement"

export const initializeSendStatementRequest = (statement: StatementSummary, emailAddresses: string[], defaultDueOn?: string): SendStatementRequest & { invoiceUpdates: InvoiceSendOptions } => {
  const invoiceUpdates: InvoiceSendOptions = {
    dueOn: statement.dueOn ?? defaultDueOn,
    enableCreditCardPayments: statement.enableCreditCardPayments,
    enableAchPayments: statement.enableAchPayments,
    showAuthorizePaymentOnFile: statement.showAuthorizePaymentOnFile,
    requireAuthorizePaymentOnFile: statement.requireAuthorizePaymentOnFile,
  }
  return {
    statementId: statement.statementId,
    emailAddresses,
    invoiceUpdates
  }
}

export const buildStatementReminderRequest = (statement: StatementSummary, emailAddresses: string[]): SendStatementRequest => {
  return {
    statementId: statement.statementId,
    emailAddresses,
    invoiceUpdates: null,
  }
}
